export interface Schema {
  config: 'all' | 'store' | 'effects' | 'component-store' | 'signals';
}
